import React from 'react';
import {t} from '@lingui/core/macro';
import {Helmet} from 'react-helmet-async';

import {WebOnly} from 'shared/ui/PlatformWrapper/PlatformWrapper';
import CookieConsentBanner from 'shared/ui/CookieConsentBanner/CookieConsentBanner';
import SpinnerWithOverlay from 'shared/ui/SpinnerWithOverlay/SpinnerWithOverlay';
import spinnerStyles from 'shared/ui/SpinnerWithOverlay/SpinnerWithOverlay.module.scss';

export interface BaseLayoutProps  {
    children?: React.ReactNode;
    pageTitle?: string;
    isLoading?: boolean;
    // eslint-disable-next-line react/no-unused-prop-types
    className?: string;
    // eslint-disable-next-line react/no-unused-prop-types
    isPlugMode?: boolean;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({pageTitle, isLoading, children}) => (
    <>
        {
            <Helmet>
                <title>{pageTitle ?? t`Overseer`}</title>
            </Helmet>
        }
        <WebOnly>
            <CookieConsentBanner />
        </WebOnly>
        {children}
        {isLoading && <SpinnerWithOverlay className={spinnerStyles.layout}/>}
    </>
);

export default BaseLayout;
